import { YES_NO } from "../constants"
import type { CategorySection } from "../types"

export const franchiseSections: Record<string, CategorySection[]> = {
  Franchise: [
    {
      sectionTitle: "Franchisor / Broker Input",
      fields: [
        { key: "brandName", type: "text", label: "Brand Name", placeholder: "" },
        { key: "category", type: "text", label: "Category", placeholder: "" },
        { key: "natureOfBusiness", type: "textarea", label: "Nature of Business", placeholder: "" },
        { key: "brandWebsite", type: "text", label: "Brand Website", placeholder: "" },
        { key: "businessModelOverview", type: "textarea", label: "Business Model Overview", placeholder: "" },
      ],
    },
    {
      sectionTitle: "Opportunity Details",
      fields: [
        { key: "auctionTitle", type: "text", label: "Auction Title", placeholder: "" },
        { key: "franchiseTerritoryOnOffer", type: "text", label: "Franchise Territory on Offer", placeholder: "" },
        { key: "typeOfRightsOffered", type: "text", label: "Type of Rights Offered", placeholder: "" },
        { key: "franchiseAgreementTerm", type: "text", label: "Franchise Agreement Term", placeholder: "" },
        { key: "isAgreementRenewable", type: "yesno", label: "Is the Agreement Renewable?", options: YES_NO },
        { key: "renewalTerms", type: "textarea", label: "Renewal Terms", placeholder: "" },
      ],
    },
    {
      sectionTitle: "Investment & Financials",
      fields: [
        { key: "estimatedOutletSetupCost", type: "number", label: "Estimated Outlet Setup Cost", placeholder: "" },
        { key: "royaltyCommissionStructure", type: "textarea", label: "Royalty / Commission Structure", placeholder: "" },
        { key: "expectedRoiPaybackPeriod", type: "text", label: "Expected ROI / Payback Period", placeholder: "" },
      ],
    },
    {
      sectionTitle: "Support & Training",
      fields: [
        { key: "franchisorSupportProvided", type: "textarea", label: "Franchisor Support Provided", placeholder: "" },
        { key: "trainingDetails", type: "textarea", label: "Training Details", placeholder: "" },
      ],
    },
    {
      sectionTitle: "Media",
      fields: [
        { key: "brandLogo", type: "text", label: "Brand Logo", placeholder: "" },
        { key: "outletImagesDeck", type: "text", label: "Outlet Images / Deck", placeholder: "" },
      ],
    },
  ],
}
